import { type EpisodeOfCareInfo } from 'src/types/webContracts';
import { type Svg } from '@/types/assets';
import {
  ankle,
  core,
  general,
  foot,
  heart,
  hip,
  injection,
  knee,
  lowerExtremity,
  shoulder,
  spine,
  upperExtremity,
  wristHand,
  footAnkle
} from '@/assets';

export function factorProcedures(eocs: EpisodeOfCareInfo[], overrideLengthCheck: boolean = false, isMagicLinkUser: boolean = false): EpisodeOfCareInfo[] {
  if (eocs.length === 1 && overrideLengthCheck == false) {
    return eocs;
  }

  eocs.filter(p => p.status !== 1);
  eocs.forEach(function (episode) {
    episode.bodyPartIcon = factorProcedureIcon(episode.bodyPartName);
    if (isMagicLinkUser) {
      episode.totalAlerts = episode.alerts.surveyTasks;
      episode.alerts.tasks = episode.alerts.surveyTasks;
      episode.alerts.messages = 0;
      episode.alerts.videoVisit = 0;
    }
    else {
      episode.totalAlerts = episode.alerts.tasks + episode.alerts.messages + episode.alerts.videoVisit;
    }
  });

  return eocs;
}

function factorProcedureIcon(bodyPartName: string): Svg | string {
  switch (bodyPartName) {
    case 'Ankle':
      return ankle;
    case 'Cardio_Thoracic':
    case 'Heart':
      return heart;
    case 'Cervical_Spine':
    case 'Lumbar_Spine':
    case 'Neck':
      return spine;
    case 'Core':
      return core;
    case 'General':
      return general;
    case 'Foot':
      return foot;
    case 'Foot/Ankle':
      return footAnkle;
    case 'Pelvis':
    case 'Hip':
      return hip;
    case 'Image_Viewer':
      return 'fa-regular fa-x-ray';
    case 'Injection':
      return injection;
    case 'Knee':
      return knee;
    case 'Lower_Extremity':
    case 'Leg':
      return lowerExtremity;
    case 'Shell_Procedure':
      return 'fa-regular fa-house';
    case 'Shoulder':
      return shoulder;
    case 'Upper_Extremity':
    case 'Elbow':
    case 'Arm':
    case 'Arm/Elbow':
      return upperExtremity;
    case 'Wrist/Hand':
      return wristHand;
    default:
      return '';
  }
}
